import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["translateY", "buttonProps"];
import React from "react";
import { Tooltip } from "../Popover";
import Box from "../Box";
import InfoSystemButton from "../InfoSystemButton";
export var Content = function Content(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    p: "20px",
    role: "dialog",
    maxWidth: ["85vw", "350px"]
  }, props));
};

var InfoTooltip = function InfoTooltip(_ref) {
  var _ref$translateY = _ref.translateY,
      translateY = _ref$translateY === void 0 ? "-2px" : _ref$translateY,
      buttonProps = _ref.buttonProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    containerProps: {
      display: "inline-block"
    },
    target: function target(_ref2) {
      var ref = _ref2.ref,
          isHidden = _ref2.isHidden,
          setHidden = _ref2.setHidden;
      return /*#__PURE__*/React.createElement(InfoSystemButton, _extends({
        as: "button",
        type: "button",
        display: "inline",
        tabIndex: "0",
        onClick: function onClick() {
          return setHidden(!isHidden);
        },
        ref: ref,
        translateY: translateY
      }, buttonProps));
    },
    placement: "bottom"
  }, props));
};

InfoTooltip.Content = Content;
export default InfoTooltip;